module.exports = __webpack_public_path__ + "static/media/white_logo_transparent_background.331d6cd5.png";